__turbopack_context__.v({
  "borderedInputWrapper": "DatePicker-module__ijUrda__borderedInputWrapper",
  "todayHighlight": "DatePicker-module__ijUrda__todayHighlight",
});
